// Every user-visible production change should be added at the top of this feed.
export const productUpdates = [
  {
    id: "2026-10-08-rental-preview",
    date: "8. 10. 2026",
    type: "fix",
    label: "Príjem z prenájmu",
    title: "Náhľad príjmu rešpektuje začiatok nájmu a pravidlá bánk",
    summary: "Začiatok nájmu možno zvoliť až po aktuálny mesiac aj v Safari. Náhľad teraz používa zadaný dátum aj údaj o zdanení. Pri neakceptovanom nájme zobrazí dôvod a požadované minimálne trvanie v mesiacoch podľa konkrétnej banky. Prepočet sa obnoví po zmene mesiaca alebo zdanenia.",
  },
  {
    id: "2026-10-08-market-articles",
    date: "8. 10. 2026",
    type: "product",
    label: "Poradňa a kampane",
    title: "Sedem nových prehľadov zmien hypoték",
    summary: "Poradňa obsahuje nové články o SLSP, ČSOB, 365.bank, UniCredit, VÚB, mBank a ukončení ponuky Prima banky. Články uvádzajú účinnosť, podmienky a existujúce ilustrácie. Nové sadzby 365.bank platia od 8. októbra; skrátenie čerpania na dva mesiace sa aktivuje 15. októbra. Ponuka Prima 3,60 % / 3,80 % skončila a čaká na nový sadzobník.",
  },
  {
    id: "2026-10-06-mortgage-market",
    date: "8. 10. 2026",
    type: "product",
    label: "Sadzby a metodika bánk",
    title: "Októbrové sadzby a kampane s dátumami účinnosti",
    summary: "Nové podklady pre mBank, VÚB, SLSP, UniCredit a ČSOB. SLSP: mladí a 90 za 80. ČSOB: hranica nad 30 000 EUR. 365.bank mení sadzby 8. 10. a čerpanie 15. 10.; Prima končí ponuku 7. 10. Podmienky v bankových poznámkach a Poradni; sadzby sa načítavajú z API.",
  },
  {
    id: "2026-09-09-client-creation-income-progress",
    date: "9. 9. 2026",
    type: "fix",
    label: "Klienti a hypotéky",
    title: "Nový klient priamo pri konzultácii a viditeľný prepočet príjmu",
    summary: "Pri plánovaní konzultácie vytvoríte klienta bez zadávania hypotéky. Pri uložení príjmu vidíte priebeh až do dokončenia prepočtu. Výber klienta a potvrdenie novej hypotéky sú samostatné kroky.",
  },
  {
    id: "2026-09-01-settings-top-navigation",
    date: "1. 9. 2026",
    type: "fix",
    label: "Nastavenia",
    title: "Sekcie nastavení už nezaberajú ľavý stĺpec",
    summary: "Obsah webu, úrokové sadzby, finančníci, kampane a feedback sú v kompaktnej hornej navigácii. Redakčný prehľad aj ostatné nastavenia tak využívajú celú šírku obrazovky; na menšom displeji sa lišta pohodlne posúva do strán.",
  },
  {
    id: "2026-09-01-editorial-performance-cards",
    date: "1. 9. 2026",
    type: "fix",
    label: "Obsah webu",
    title: "Výkon článkov je prehľadnejší a bez širokej tabuľky",
    summary: "Publikované články majú kompaktnejšie karty bez horizontálneho posúvania. SEO údaje, skóre, metriky, trend, odporúčanie, termín aj akcie sú rozdelené do jasných blokov a lepšie sa čítajú aj na menšej obrazovke.",
  },
  {
    id: "2026-09-01-editorial-article-performance",
    date: "1. 9. 2026",
    type: "product",
    label: "Obsah webu",
    title: "Slabšie články nájdete ako prvé",
    summary: "Pri každom publikovanom článku vidíte kliknutia, zobrazenia, CTR, pozíciu, návštevy, prioritu aj zlepšenie či pokles oproti predošlému obdobiu. Zoznam sa dá zoradiť od najslabších výsledkov aj podľa najväčšej zmeny.",
  },
  {
    id: "2026-08-27-ai-bank-application-generation",
    date: "27. 8. 2026",
    type: "product",
    label: "Žiadosti o hypotéku",
    title: "AI pripraví bankovú žiadosť z údajov klienta",
    summary: "Pre 365.bank, ČSOB, Prima banku a UniCredit vyplní Broker po kliknutí dostupné údaje zo žiadosti, žiadateľov, príjmov, záväzkov a nehnuteľností priamo do bankového PDF. Dokument zostane otvorený na kontrolu a úpravy; Uložiť zapíše jeho aktuálnu verziu priamo do cloudu hypotéky.",
  },
  {
    id: "2026-08-19-drawdown-document-layout",
    date: "19. 8. 2026",
    type: "fix",
    label: "Čerpanie a dokumenty",
    title: "Záznam o sprostredkovaní má vlastné miesto",
    summary: "V kroku Čerpanie je záznam oddelený od bankových zmlúv, má vlastný nadpis a ukladá sa do cloudu celej hypotéky. Upload karty a akcie dokumentov dostali jednotné ikony, kompaktnejšie rozostupy a prehľadnejšie stavy.",
  },
  {
    id: "2026-08-19-brokerage-record-drawdown-upload",
    date: "19. 8. 2026",
    type: "product",
    label: "Čerpanie a dokumenty",
    title: "Záznam o sprostredkovaní uložíte priamo k obchodu",
    summary: "Podpísaný záznam o sprostredkovaní a potrebách klienta pribudol medzi dokumenty v kroku Čerpanie aj do centrálneho checklistu. Priložiť ho môžete aj pri rýchlom zápise už načerpaného obchodu; systém ho uloží priamo do cloudu hypotéky.",
  },
  {
    id: "2026-08-19-website-consultation-banner-images",
    date: "19. 8. 2026",
    type: "fix",
    label: "bankari.sk",
    title: "Konzultačné bannery opäť zobrazujú Dominika",
    summary: "Homepage, bankové podstránky aj manuály používajú stabilné názvy obrázkov bez problémových znakov. Portrét Dominika Petroviča sa preto načíta na každom konzultačnom banneri a text tmavého CTA tlačidla má opäť čitateľnú bielu farbu.",
  },
  {
    id: "2026-08-18-public-consultation-booking",
    date: "18. 8. 2026",
    type: "product",
    label: "bankari.sk",
    title: "Webové konzultácie už nepoužívajú Fillout",
    summary: "Dohodnutie konzultácie je dvojkrokové priamo na bankari.sk. Najprv sa podľa okresu nehnuteľnosti vyberie finančník z daného regiónu, potom klient vidí jeho reálne voľné termíny, doplní kontakt a rezervácia sa zapíše do spoločného kalendára aj s videohovorom.",
  },
  {
    id: "2026-08-18-broker-consultation-scheduling",
    date: "18. 8. 2026",
    type: "product",
    label: "Kalendár a klienti",
    title: "Konzultáciu môže naplánovať aj bankár",
    summary: "Voľný termín vyberiete kliknutím alebo potiahnutím priamo v kalendári. Rovnaký výber je dostupný v detaile klienta cez tlačidlo Naplánovať konzultáciu; udalosť sa uloží obom stranám, vytvorí bezpečný videohovor a skontroluje kolízie.",
  },
  {
    id: "2026-08-18-editorial-organic-overview",
    date: "18. 8. 2026",
    type: "product",
    label: "Redakčný plán",
    title: "Organický výkon článkov vidíte na jednom mieste",
    summary: "Nad redakčným zoznamom pribudol súhrn kliknutí a zobrazení z Google, priemernej pozície, návštev manuálov aj preklikov na prepočet. Prepínač porovná posledných 7, 28 alebo 90 dní a detail článku zostáva dostupný samostatne.",
  },
  {
    id: "2026-08-18-client-debt-delete",
    date: "18. 8. 2026",
    type: "product",
    label: "Výdavky klienta",
    title: "Nepotrebný výdavok môžete bezpečne zmazať",
    summary: "Pri evidovaných úverových výdavkoch pribudlo mazanie s potvrdením. Dlh vytvorený z načerpanej žiadosti a previazaný so systémovou hypotékou je chránený na obrazovke aj priamo v API a upravuje sa výhradne cez detail hypotéky.",
  },
  {
    id: "2026-08-18-editorial-published-backfill",
    date: "18. 8. 2026",
    type: "fix",
    label: "Redakčný plán",
    title: "Staršie publikované články sú plnohodnotne v editore aj na webe",
    summary: "Redakčný systém spätne preberá text, SEO, titulný obrázok aj živú publikačnú verziu všetkých verejných manuálov. Náhľad zobrazuje presne aktuálnu verziu z webu a všetky staršie články dostávajú rovnakú novú hlavičku, typografiu, CTA, navigáciu aj pätu ako najnovší článok.",
  },
  {
    id: "2026-08-18-editorial-public-layout",
    date: "18. 8. 2026",
    type: "fix",
    label: "Poradňa bankari.sk",
    title: "Nové články používajú spoločnú navigáciu a pätu webu",
    summary: "Čerstvo publikované články už vizuálne patria k ostatným manuálom: majú rovnaké menu, prihlasovanie, pätičku aj kontaktný widget. Modernejšie rozloženie titulku, podtitulku a titulného obrázka zostalo zachované.",
  },
  {
    id: "2026-08-18-settings-editorial-default",
    date: "18. 8. 2026",
    type: "product",
    label: "Nastavenia",
    title: "Obsah webu je hlavná sekcia nastavení",
    summary: "Redakčný prehľad článkov, nápadov a SEO sa po otvorení Nastavení zobrazí ako prvý. Obsah webu je zároveň prvou položkou v zozname sekcií, takže sa k dennej redakčnej práci dostanete bez ďalšieho klikania.",
  },
  {
    id: "2026-08-18-editorial-google-analytics",
    date: "18. 8. 2026",
    type: "product",
    label: "Redakčný plán",
    title: "Výkon článkov spojí GA4 a Google Search Console",
    summary: "Pri publikovaných článkoch pribudol prehľad návštev, kliknutí z Googlu, CTR, priemernej pozície, vyhľadávacích dopytov a kliknutí na prepočet. Systém navrhne, kde upraviť titulok, obsah, prelinkovanie alebo CTA a údaje obnovuje denne.",
  },
  {
    id: "2026-08-18-prima-youth-three-percent",
    date: "18. 8. 2026",
    type: "article",
    label: "Nová kampaň",
    bank: "Prima banka",
    title: "Hypotéka pre mladých za 3,00 % s fixáciou na 30 mesiacov",
    summary: "Pre žiadateľov do 35 rokov platí pri hypotékach schválených do 30. 9. 2026 sadzba 3,00 %. Ponuka sa vzťahuje aj na prenos hypotéky a banka uvádza možnosť preplatenia poplatku za predčasné splatenie.",
  },
  {
    id: "2026-08-17-editorial-preview-scroll",
    date: "17. 8. 2026",
    type: "fix",
    label: "Redakčný plán",
    title: "Celý náhľad článku sa dá pohodlne posúvať",
    summary: "Publikačný náhľad už nie je otvorený nad druhým modalom. Počas kontroly dočasne nahradí editor, má vlastný scroll nad obrázkom, textom aj publikačným panelom a po zavretí sa bezpečne vrátite k rozpracovaným zmenám.",
  },
  {
    id: "2026-08-17-editorial-preview-publishing",
    date: "17. 8. 2026",
    type: "product",
    label: "Redakčný plán",
    title: "Článok skontrolujete a publikujete priamo z náhľadu",
    summary: "Redakčný modal má titulný obrázok a samostatný náhľad vzhľadu na bankari.sk. Checklist preverí text, SEO aj zdroje; po odsúhlasení prepínačom článok jedným kliknutím publikujete, aktualizujete alebo stiahnete z webu.",
  },
  {
    id: "2026-08-17-editorial-author-ready-final-draft",
    date: "17. 8. 2026",
    type: "product",
    label: "Redakčný plán",
    title: "Hotové autorské vstupy označíte priamo pri článku",
    summary: "V redakčnom modale pribudol checkbox, ktorým dá autor najavo, že poznámky sú kompletné a článok je pripravený na finálne marketingové spracovanie. V prehľade sa taký článok označí štítkom Vstupy hotové.",
  },
  {
    id: "2026-08-13-editorial-top20-researched-drafts",
    date: "13. 8. 2026",
    type: "product",
    label: "Redakčný plán",
    title: "Prvých 20 SEO článkov má poctivé podklady aj harmonogram",
    summary: "Najsilnejšie témy sme rozdelili po štyroch na päť dní. Každá má pôvodný pracovný text, modelový príklad, overené zdroje, upozornenia na meniace sa bankové pravidlá a prirodzenú výzvu na prepočet hypotéky v aplikácii.",
  },
  {
    id: "2026-08-13-editorial-drafts-research-modal",
    date: "13. 8. 2026",
    type: "product",
    label: "Redakčný prehľad",
    title: "Návrhy článkov, zdroje a poznámky v prehľadnom modale",
    summary: "Úprava článku už nerozťahuje tabuľku. V samostatnom modale je oddelený pracovný návrh textu, stav overenia a primárne zdroje aj vlastná redakčná poznámka pre ďalšie kolo spracovania.",
  },
  {
    id: "2026-08-13-non-negative-loan-limit",
    date: "13. 8. 2026",
    type: "product",
    label: "Výpočet hypotéky",
    title: "Maximálny úver vyberá iba platné limity bánk",
    summary: "Záporný alebo neplatný výsledok jednej banky už nemôže prepísať dostupný limit z ostatných bánk. Broker vyberie najvyšší úspešný nezáporný limit a korekciu súm vykoná iba vtedy, keď je skutočne potrebná.",
  },
  {
    id: "2026-08-13-client-name-search",
    date: "13. 8. 2026",
    type: "product",
    label: "Vyhľadávanie klientov",
    title: "Mená nájdete aj podľa krátkej časti slova",
    summary: "Vyhľadávanie klientov je spoľahlivé aj pri krátkych fragmentoch mena, napríklad pri písmene y. Naďalej ignoruje rozdiely v diakritike a podporuje aj telefónne čísla v bežných formátoch.",
  },
  {
    id: "2026-08-13-income-employer-refresh",
    date: "13. 8. 2026",
    type: "product",
    label: "Príjmy klienta",
    title: "Údaje zamestnávateľa sa zobrazia ihneď po uložení",
    summary: "Názov spoločnosti dohľadaný podľa IČO sa po uložení okamžite zobrazí v prehľade príjmov aj pri opätovnom otvorení formulára. Už nie je potrebné obnovovať stránku.",
  },
  {
    id: "2026-08-13-application-signing-workflow",
    date: "13. 8. 2026",
    type: "product",
    label: "Žiadosti o hypotéku",
    title: "Podpisovanie a podanie žiadosti bez duplicitných krokov",
    summary: "Banky bez vlastného tlačiva označíte ako podpísané jedným kliknutím. Pri bankách s tlačivom si vyberiete, či chcete iba zmeniť stav alebo nahrať aj podpísaný dokument. Presun do stavu Podaná sa po úspešnom uložení už nevráti do pôvodného stĺpca.",
  },
  {
    id: "2026-08-13-bank-application-documents",
    date: "13. 8. 2026",
    type: "product",
    label: "Dokumenty bánk",
    title: "Aktuálne žiadosti a súvisiace tlačivá na jednom mieste",
    summary: "Pre 365.bank, ČSOB, Prima banku a UniCredit sme doplnili aktuálne editovateľné žiadosti vrátane verzií pre jedného či dvoch žiadateľov a súvisiacich protokolov alebo vyhlásení. Banky s online podaním používajú vlastný dátový prehľad.",
  },
  {
    id: "2026-08-12-tatra-youth-campaign",
    date: "12. 8. 2026",
    type: "article",
    label: "Nová kampaň",
    bank: "Tatra banka",
    title: "Hypotéka pre mladých od 3,59 % a bonus 500 €",
    summary: "Mladí do 34 rokov môžu pri prvom bývaní získať 3-ročnú sadzbu od 3,59 %, financovanie do 90 % LTV, bonus 500 € a zvýhodnené dofinancovanie.",
    link: "https://www.bankari.sk/manualy/tatra-banka-hypoteka-pre-mladych-od-3-59-a-bonus-500-eur",
    linkLabel: "Prečítať podmienky kampane",
  },
  {
    id: "2026-08-11-client-app-results",
    date: "11. 8. 2026",
    type: "product",
    label: "Klientská aplikácia",
    title: "Výsledky analýzy vedú klienta priamo k ďalšiemu kroku",
    summary: "Klient vidí prehľad limitu, presnosti analýzy a ponúk bánk v novom mobilnom rozhraní. Vybrané riešenia sa zoskupia pri výzve na konzultáciu a výber fixácie sa bankárovi uloží ako jasný záujem klienta.",
  },
  {
    id: "2026-08-11-client-app-analysis-documents",
    date: "11. 8. 2026",
    type: "product",
    label: "Klientská aplikácia",
    title: "Detailnejšia analýza a doklady sú prehľadnejšie",
    summary: "Formuláre príjmov, výdavkov, úverov a nehnuteľností majú jednotné ovládanie a zrozumiteľnejší stav dokončenia. Zoznam podkladov sa skladá podľa účelu hypotéky a údajov klienta; nahrávanie ukazuje priebeh, stav aj chybu na správnom mieste.",
  },
  {
    id: "2026-08-11-client-app-support-identity",
    date: "11. 8. 2026",
    type: "product",
    label: "Klientská aplikácia",
    title: "Otázky, články a overenie identity bez slepých uličiek",
    summary: "Namiesto očakávania živého chatu môže klient zanechať otázku bankárovi. V aplikácii si prečíta aktuálne články bez presmerovania a obnovené Sumsub overenie ukladá výsledok, údaje aj doklady tak, aby boli dostupné v Brokeri.",
  },
  {
    id: "2026-08-05-foreign-income-article",
    date: "5. 8. 2026",
    type: "article",
    label: "Nový metodický článok",
    title: "Príjem zo zahraničia a v cudzej mene",
    summary: "Porovnali sme krajiny, meny, pracovnú históriu, LTV a doklady v ôsmich bankách. Broker pri zahraničnom zamestnaní po novom vyžaduje názov zamestnávateľa aj krajinu.",
    link: "https://www.bankari.sk/manualy/prijem-zo-zahranicia-a-v-cudzej-mene-pri-hypoteke",
    linkLabel: "Prečítať porovnanie bánk",
  },
  {
    id: "2026-08-05-service-refixation",
    date: "5. 8. 2026",
    type: "product",
    label: "Servis hypoték",
    title: "Presná refixácia a automatický výpočet splátky",
    summary: "Nová sadzba môže mať desatinné miesta, fixácia má vlastné trvanie a dátum. Splátka sa ráta z aktuálneho zostatku a zostávajúcich mesiacov bez prepísania pôvodného čerpania.",
  },
  {
    id: "2026-08-05-lost-and-archive",
    date: "5. 8. 2026",
    type: "product",
    label: "Klienti a hypotéky",
    title: "Prehrané obchody odlišujeme od zrušených",
    summary: "Ak klient odíde ku konkurencii, hypotéku označíte ako Prehranú s dôvodom. Archivovanie klienta zruší iba jeho otvorené hypotéky; zrušenie hypotéky nikdy nearchivuje klienta.",
  },
  {
    id: "2026-08-05-tatra-penalty",
    date: "5. 8. 2026",
    type: "article",
    label: "Obnovená kampaň",
    bank: "Tatra banka",
    title: "Tatra banka preplatí pokutu pri prenose hypotéky",
    summary: "Pri refinancovaní preplatí 100 % nákladov na predčasné splatenie, najviac 1 % z predčasne splácanej sumy úveru.",
    link: "https://www.bankari.sk/kampane/tatra-banka/prenos-hypoteky-do-tatra-banky-sa-teraz-oplati",
    linkLabel: "Pozrieť podmienky kampane",
  },
  {
    id: "2026-08-05-bank-methodology",
    date: "5. 8. 2026",
    type: "methodology",
    label: "Metodika bánk",
    title: "Aktualizovali sme ČSOB, 365.bank a Tatra banku",
    summary: "Zapracovali sme nové sadzby ČSOB, pravidlá 90 % LTV, kratšiu lehotu čerpania v 365.bank a developerskú zľavu Tatra banky.",
  },
  {
    id: "2026-08-05-refinancing-workflow",
    date: "5. 8. 2026",
    type: "product",
    label: "Hypotéky a servis",
    title: "Prehľadnejšie modelácie a refinancovanie",
    summary: "Rozhodnutie, či dlh ponecháte, splatíte alebo refinancujete, sa ukladá samostatne ku každej modelácii. Údaje zdieľame iba medzi hypotékami s rovnakými žiadateľmi.",
  },
  {
    id: "2026-08-05-offer-shortcuts",
    date: "5. 8. 2026",
    type: "product",
    label: "Výsledky bánk",
    title: "Rýchle nastavenia ponúk a jasnejšie výsledky",
    summary: "Jedným kliknutím nastavíte 90 % LTV alebo používanie účtu vo všetkých podporovaných bankách. Ak ponuky nevzniknú, výsledok už vysvetlí konkrétny dôvod.",
  },
  {
    id: "2026-08-05-feedback-and-documents",
    date: "5. 8. 2026",
    type: "product",
    label: "Podklady a podpora",
    title: "Lepšie podklady a hlásenie problémov",
    summary: "V podkladoch zobrazujeme zamestnávateľa, ZIP obsahuje iba vybrané dokumenty a pri chybe nahrávania uvidíte zrozumiteľnú správu. Feedback automaticky priloží stránku a môže obsahovať screenshot.",
  },
  {
    id: "2026-08-05-quick-deal",
    date: "5. 8. 2026",
    type: "product",
    label: "Nový obchod",
    title: "Načerpanú hypotéku zaevidujete bez celého procesu",
    summary: "V detaile klienta pribudla skratka na rýchle zaevidovanie už načerpanej hypotéky vrátane sadzby, splatnosti a dátumu čerpania.",
  },
  {
    id: "2026-08-05-csob-article",
    date: "5. 8. 2026",
    type: "article",
    label: "Nový článok",
    bank: "ČSOB",
    title: "Nové sadzby a rozšírenie 90 % LTV",
    summary: "Praktický prehľad sadzieb platných od 4. augusta a podmienok, za ktorých možno financovať rodinný dom na 90 % LTV.",
    link: "https://www.bankari.sk/manualy/csob-meni-urokove-sadzby-a-rozsiruje-90-ltv-od-4-augusta-2026",
    linkLabel: "Prečítať článok",
  },
  {
    id: "2026-08-05-365-article",
    date: "5. 8. 2026",
    type: "article",
    label: "Nový článok",
    bank: "365.bank",
    title: "Kratšia lehota na čerpanie hypotéky",
    summary: "Čo znamená nová štvormesačná lehota a kedy možno využiť urgentné čerpanie do dvoch pracovných dní.",
    link: "https://www.bankari.sk/manualy/365-bank-skracuje-lehotu-na-cerpanie-hypoteky-od-15-augusta-2026",
    linkLabel: "Prečítať článok",
  },
  {
    id: "2026-08-05-tatra-article",
    date: "5. 8. 2026",
    type: "article",
    label: "Nový článok",
    bank: "Tatra banka",
    title: "Zľava pri developerskom projekte",
    summary: "Ako funguje automatická zľava 0,10 percentuálneho bodu a s ktorými ďalšími výhodami ju možno kombinovať.",
    link: "https://www.bankari.sk/manualy/tatra-banka-zlava-na-hypoteku-v-developerskom-projekte-od-augusta-2026",
    linkLabel: "Prečítať článok",
  },
  {
    id: "2026-08-04-vub-mbank-365",
    date: "4. 8. 2026",
    type: "methodology",
    label: "Metodika bánk",
    title: "Spresnili sme splatnosť VÚB a podnikateľské príjmy",
    summary: "Vo VÚB môže hypotéka končiť vo veku 72 rokov bez ohľadu na dnešný vek. V mBank sme doplnili limity príjmu z jednej s.r.o. a v 365.bank pravidlo 40-ročnej splatnosti.",
  },
];

export const latestProductUpdateId = productUpdates[0].id;
